import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import TimelineItem from './TimelineItem';
import splitObject from './splitObject';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  /** 指定最后一个幽灵节点是否存在或内容 */
  pending: PropTypes.oneOfType([PropTypes.bool, PropTypes.node])
};
var defaultProps = {}; //static Item: React.ReactNode;  TimelineProps

var Timeline = (_dec = WebUI({
  name: "timeline"
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Timeline, _React$Component);

  var _super = _createSuper(Timeline);

  function Timeline() {
    _classCallCheck(this, Timeline);

    return _super.apply(this, arguments);
  }

  _createClass(Timeline, [{
    key: "render",
    value: function render() {
      var _splitObject = splitObject(this.props, ['clsPrefix', 'children', 'pending', 'className']),
          _splitObject2 = _slicedToArray(_splitObject, 2),
          _splitObject2$ = _splitObject2[0],
          clsPrefix = _splitObject2$.clsPrefix,
          children = _splitObject2$.children,
          pending = _splitObject2$.pending,
          className = _splitObject2$.className,
          restProps = _splitObject2[1];

      var pendingNode = typeof pending === 'boolean' ? null : pending;
      var classString = classNames(clsPrefix, _defineProperty({}, "".concat(clsPrefix, "-pending"), !!pending), className);
      var items = React.Children.map(children, function (ele, idx) {
        return /*#__PURE__*/React.cloneElement(ele, {
          last: idx === children.length - 1
        });
      });
      var pendingItem = !!pending ? /*#__PURE__*/React.createElement(TimelineItem, {
        pending: !!pending
      }, pendingNode) : null;
      return /*#__PURE__*/React.createElement("ul", _extends({}, restProps, {
        className: classString
      }), items, pendingItem);
    }
  }]);

  return Timeline;
}(React.Component)) || _class);
Timeline.propTypes = propTypes;
export default Timeline;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-timeline/src/Timeline.js